import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ShaftSealProductQuery } from '../../models/shaft-seal-product-query.interface';
import { ShaftSealProductOptions } from '../../models/shaft-seal-product-options.interface';

@Component({
  selector: 'shaft-seal-product-form',
  styles: [`
    .pss-form__help-text {
      margin-bottom: 10px;
      display: block;
      font-size: 16px;
    }
    select.form-control {
      width: 100%;
    }
    .input-group {
      display: block;
    }
    .form-margin {
      margin-top: 25px;
    }
    label.radio-inline {
      min-width: 100px;
    }
    .btn--reset {
      position: absolute;
      right: -5px;
      top: -5px;
      display: inline-block;
    }
    form {
      position: relative;
    }
  `],
  template: `
    <form #form="ngForm" novalidate role="form">
      <button
        *ngIf='!form.pristine'
        (click)='handleUpdate(form.value, "all"); form.reset()'
        class="btn btn--reset btn-xs">
        Reset Search
      </button>
      <div class="row">
        <div class="col-md-12 form-margin">
          <span class="pss-form__help-text">1) Do you need Imperial or metric sizing?</span>
          <div class="input-group">
            <label class="custom-control custom-radio radio-inline">
              <input
                type="radio"
                [value]="false"
                id="metric_false"
                name="shaft_diameter_metric"
                #shaft_diameter_metric
                class="custom-control-input"
                [ngModel]="form_query?.shaft_diameter_metric"
                (change)='handleUpdate(form.value, "shaft_diameter_metric")'>
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">Imperial</span>
            </label>

            <label class="custom-control custom-radio radio-inline">
              <input
                type="radio"
                [value]="true"
                id="metric_true"
                name="shaft_diameter_metric"
                class="custom-control-input"
                [ngModel]="form_query?.shaft_diameter_metric"
                (change)='handleUpdate(form.value, "shaft_diameter_metric")'>
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">Metric</span>
            </label>
           </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 form-margin">
           <label for="shaft_diameter" class="pss-form__help-text">2) Select your shaft diameter</label>
           <div class="input-group">
             <select
               class="form-control"
               name="shaft_diameter"
               [disabled]="!!!shaft_diameter_options"
               [ngModel]="form_query?.shaft_diameter"
               (change)='handleUpdate(form.value, "shaft_diameter")'>
                 <option
                   *ngFor="let item of shaft_diameter_options"
                   [value]='item.key'
                   [selected]='item.key === form_query?.shaft_diameter'>
                   {{ item.value }}
                 </option>
              </select>
           </div>
        </div>
        <div class="col-md-6 form-margin">

           <label for="stern_tube_diameter" class="pss-form__help-text">3) Select the outside diameter of your stern tube <em>(shaft log)</em>:</label>
           <div class="input-group">
             <select
               class="form-control"
               name="stern_tube_diameter"
               [disabled]="!!!stern_tube_diameter_options"
               [ngModel]="form_query?.stern_tube_diameter"
               (change)='handleUpdate(form.value, "stern_tube_diameter")'>
                 <option
                   *ngFor="let item of stern_tube_diameter_options"
                   [value]='item.key'
                   [selected]='item.key === form_query?.stern_tube_diameter'>
                   {{ item.value }}
                 </option>
              </select>
           </div>
        </div>
      </div>
    </form>
  `
})

export class ShaftSealProductFormComponent {
  @Input() form_query: ShaftSealProductQuery;
  @Input() shaft_diameter_options: ShaftSealProductOptions[];
  @Input() stern_tube_diameter_options: ShaftSealProductOptions[];

  @Output() update: EventEmitter<ShaftSealProductQuery> = new EventEmitter<ShaftSealProductQuery>();

  handleUpdate(query: ShaftSealProductQuery, clear: string) {

    if (clear === 'shaft_diameter_metric') {

      query['shaft_diameter'] = null;
      query['stern_tube_diameter'] = null;

    } else if (clear === 'shaft_diameter') {
      query['stern_tube_diameter'] = null;
    } else if (clear === 'all') {
      query['shaft_diameter'] = null;
      query['stern_tube_diameter'] = null;
      query['shaft_diameter_metric'] = null;
    }

    this.update.emit(query);
  }


}


// WEBPACK FOOTER //
// ./app/javascript/product_search/app/shaft-seal-product-selector/components/shaft-seal-product-form/shaft-seal-product-form.component.ts